import React, { useEffect, useState, createElement } from 'react';
import { Brain, Lock, Zap, Eye, Shield, ChevronRight, Play, CheckCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
const COURSE_SECTIONS = [{
  title: 'Semana 1',
  subtitle: 'Reprograma tu Mente',
  description: 'Elimina el ruido mental y establece las bases de tu nueva identidad.',
  icon: Brain
}, {
  title: 'Semana 2',
  subtitle: 'Enfoque Profundo',
  description: 'Accede a estados alterados de concentración y claridad absoluta.',
  icon: Eye
}, {
  title: 'Semana 3',
  subtitle: 'Identidad Imparable',
  description: 'Despierta la versión más poderosa de ti mismo a nivel subconsciente.',
  icon: Shield
}, {
  title: 'Semana 4',
  subtitle: 'Éxito Automático',
  description: 'Programa tu sistema nervioso para operar en modo de alto rendimiento.',
  icon: Zap
}, {
  title: '7 Días para Activar Abundancia',
  subtitle: 'Bonus Final',
  description: 'El ritual de cierre que sella tu transformación y activa el flujo de abundancia.',
  icon: Lock
}];
export function MeditationsPage() {
  const [activeSection, setActiveSection] = useState<number | null>(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
  }, []);
  const fadeIn = {
    initial: {
      opacity: 0,
      y: 20
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true
    },
    transition: {
      duration: 0.6
    }
  };
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-purple-500/30" data-id="element-3010">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-3011">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-3012" />
      </noscript>

      {/* Ambient Background */}
      <div className="fixed inset-0 z-0 pointer-events-none" data-id="element-3013">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-purple-900/10 rounded-full blur-[150px]" data-id="element-3014" />
        <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-indigo-900/8 rounded-full blur-[120px]" data-id="element-3015" />
      </div>

      {/* Hero Section */}
      <section className="relative z-10 pt-12 md:pt-20 pb-16 md:pb-24 overflow-hidden" data-id="element-3016">
        <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-3017">
          {/* Badge */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 bg-purple-500/10 border border-purple-500/30 rounded-full px-5 py-2 mb-6" data-id="element-3018">
            <Lock className="w-4 h-4 text-purple-400" data-id="element-3019" />
            <span className="text-purple-400 text-xs md:text-sm font-bold uppercase tracking-widest" data-id="element-3020">
              Frequencia Prohibida
            </span>
          </motion.div>

          {/* Main Headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-4xl md:text-6xl lg:text-7xl font-black uppercase leading-none tracking-tight mb-6" data-id="element-3021">
            Reprograma Tu Mente{' '}
            <span className="bg-gradient-to-r from-purple-400 via-violet-400 to-indigo-400 bg-clip-text text-transparent" data-id="element-3022">
              En 30 Días
            </span>
          </motion.h1>

          {/* Subtitle */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed mb-4" data-id="element-3023">
            El método prohibido. La mente liberada. El nuevo tú.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="text-base md:text-lg text-gray-400 max-w-2xl mx-auto leading-relaxed mb-10" data-id="element-3024">
            Basado en el{' '}
            <span className="text-white font-semibold" data-id="element-3025">
              Informe Gateway de la CIA
            </span>
            , este reto combina hipnosis encubierta, neurocondicionamiento y
            reprogramación de identidad para transformar tu mente en solo 30
            días.
          </motion.p>

          {/* Benefits Grid */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="grid grid-cols-1 md:grid-cols-2 gap-3 max-w-2xl mx-auto mb-10 text-left" data-id="element-3026">
            {['Eliminar ruido mental y autocrítica', 'Acceder a estados de enfoque profundo', 'Despertar una identidad imparable', 'Programar tu sistema nervioso para el éxito automático'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-white/[0.03] border border-white/[0.06] rounded-xl px-4 py-3" data-id="element-3027">
                <Brain className="w-5 h-5 text-purple-400 flex-shrink-0" data-id="element-3028" />
                <span className="text-gray-200 text-sm md:text-base" data-id="element-3029">
                  {item}
                </span>
              </div>)}
          </motion.div>

          {/* Forbidden Note */}
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 0.5
        }} className="text-gray-500 text-sm italic max-w-xl mx-auto mb-10" data-id="element-3030">
            No es un curso más, es el ritual mental que estuvo oculto por
            décadas… y ahora está en tus manos.
          </motion.p>

          {/* CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} data-id="element-3031">
            <a href="#curso" className="inline-block" data-id="element-3032">
              <button className="group relative bg-gradient-to-b from-purple-500 to-purple-700 hover:from-purple-400 hover:to-purple-600 text-white font-black text-lg md:text-xl uppercase tracking-wide rounded-xl py-5 px-12 shadow-[0_0_40px_rgba(168,85,247,0.3)] transition-all duration-300 transform hover:scale-[1.02] flex items-center gap-3" data-id="element-3033">
                <Play className="w-5 h-5 fill-white" data-id="element-3034" />
                Empezar Curso
                <div className="absolute inset-0 rounded-xl overflow-hidden pointer-events-none" data-id="element-3035">
                  <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-[-25deg] group-hover:animate-shine" data-id="element-3036" />
                </div>
              </button>
            </a>

            {/* Progress */}
            <div className="mt-4 flex items-center justify-center gap-2" data-id="element-3037">
              <div className="flex gap-1" data-id="element-3038">
                {[...Array(5)].map((_, i) => <div key={i} className="w-2 h-2 rounded-full bg-gray-700" data-id="element-3039" />)}
              </div>
              <span className="text-gray-500 text-xs font-medium" data-id="element-3040">
                0 de 5 Lecciones Completadas
              </span>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Course Sections */}
      <section id="curso" className="relative z-10 py-16 md:py-24 scroll-mt-12" data-id="element-3041">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-3042">
          <motion.div {...fadeIn} className="text-center mb-12" data-id="element-3043">
            <h2 className="text-3xl md:text-4xl font-black uppercase tracking-tight mb-3" data-id="element-3044">
              Tu Camino de{' '}
              <span className="text-purple-400" data-id="element-3045">Transformación</span>
            </h2>
            <p className="text-gray-400 text-base md:text-lg" data-id="element-3046">
              5 módulos diseñados para reprogramar cada capa de tu mente.
            </p>
          </motion.div>

          <div className="space-y-4" data-id="element-3047">
            {COURSE_SECTIONS.map((section, index) => {
            const Icon = section.icon;
            const isActive = activeSection === index;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 15
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.08
            }} data-id="element-3048">
                  <button onClick={() => setActiveSection(isActive ? null : index)} className={`w-full text-left rounded-2xl border transition-all duration-300 ${isActive ? 'bg-purple-500/10 border-purple-500/40 shadow-[0_0_20px_rgba(168,85,247,0.1)]' : 'bg-white/[0.02] border-white/[0.06] hover:border-purple-500/20 hover:bg-white/[0.04]'}`} data-id="element-3049">
                    <div className="flex items-center gap-4 p-5 md:p-6" data-id="element-3050">
                      <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors ${isActive ? 'bg-purple-500/20' : 'bg-white/[0.05]'}`} data-id="element-3051">
                        <Icon className={`w-6 h-6 ${isActive ? 'text-purple-400' : 'text-gray-500'}`} data-id="element-3052" />
                      </div>
                      <div className="flex-1 min-w-0" data-id="element-3053">
                        <div className="flex items-center gap-2 mb-0.5" data-id="element-3054">
                          <span className="text-purple-400/60 text-xs font-bold uppercase tracking-wider" data-id="element-3055">
                            {section.subtitle}
                          </span>
                        </div>
                        <h3 className="text-base md:text-lg font-bold text-white truncate" data-id="element-3056">
                          {section.title}
                        </h3>
                      </div>
                      <ChevronRight className={`w-5 h-5 text-gray-500 flex-shrink-0 transition-transform duration-300 ${isActive ? 'rotate-90' : ''}`} data-id="element-3057" />
                    </div>
                    {isActive && <div className="px-5 md:px-6 pb-5 md:pb-6 pt-0" data-id="element-3058">
                        <div className="pl-16" data-id="element-3059">
                          <p className="text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-3060">
                            {section.description}
                          </p>
                        </div>
                      </div>}
                  </button>
                </motion.div>;
          })}
          </div>
        </div>
      </section>

      {/* Mentor Section */}
      <section className="relative z-10 py-16 md:py-24 border-t border-white/[0.05]" data-id="element-3061">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-3062">
          <motion.div {...fadeIn} data-id="element-3063">
            <div className="bg-gradient-to-br from-white/[0.03] to-white/[0.01] border border-white/[0.06] rounded-2xl p-6 md:p-10" data-id="element-3064">
              <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10" data-id="element-3065">
                {/* Avatar */}
                <div className="flex-shrink-0" data-id="element-3066">
                  <div className="w-24 h-24 md:w-32 md:h-32 rounded-2xl bg-gradient-to-br from-purple-500/20 to-indigo-500/20 border border-purple-500/20 flex items-center justify-center" data-id="element-3067">
                    <span className="text-4xl md:text-5xl font-black text-purple-400/50" data-id="element-3068">
                      GB
                    </span>
                  </div>
                </div>

                {/* Bio */}
                <div className="text-center md:text-left" data-id="element-3069">
                  <p className="text-purple-400 text-xs font-bold uppercase tracking-widest mb-1" data-id="element-3070">
                    Tu Mentor
                  </p>
                  <h3 className="text-2xl md:text-3xl font-black text-white mb-1" data-id="element-3071">
                    Gabriel Beltrán
                  </h3>
                  <p className="text-gray-400 text-sm font-medium mb-4" data-id="element-3072">
                    Mentor de Alto Nivel en Marketing Digital
                  </p>
                  <p className="text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-3073">
                    Gabriel Beltrán es la fuerza impulsora detrás de True
                    Marketer Academy. Su trayectoria combina el comercio
                    electrónico, el marketing de afiliados y el desarrollo
                    personal, y ha construido una reputación no solo por su
                    éxito financiero, sino por empoderar a otros a romper
                    barreras mentales y económicas.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="relative z-10 py-16 md:py-24 border-t border-white/[0.05]" data-id="element-3074">
        <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-3075">
          <motion.div {...fadeIn} data-id="element-3076">
            <p className="text-purple-400 text-sm font-bold uppercase tracking-widest mb-4" data-id="element-3077">
              ¿Estás listo?
            </p>
            <h2 className="text-3xl md:text-5xl font-black uppercase tracking-tight mb-6 leading-tight" data-id="element-3078">
              Activa Tu Acceso y Despierta el{' '}
              <span className="bg-gradient-to-r from-purple-400 to-indigo-400 bg-clip-text text-transparent" data-id="element-3079">
                Programa Oculto
              </span>{' '}
              Dentro de Ti
            </h2>
            <p className="text-gray-400 text-base md:text-lg mb-10 max-w-xl mx-auto" data-id="element-3080">
              30 días. 5 módulos. Una transformación que no tiene vuelta atrás.
            </p>

            <a href="#curso" className="inline-block" data-id="element-3081">
              <button className="group relative bg-gradient-to-b from-purple-500 to-purple-700 hover:from-purple-400 hover:to-purple-600 text-white font-black text-lg md:text-xl uppercase tracking-wide rounded-xl py-5 px-12 shadow-[0_0_40px_rgba(168,85,247,0.3)] transition-all duration-300 transform hover:scale-[1.02] flex items-center gap-3 mx-auto" data-id="element-3082">
                <Play className="w-5 h-5 fill-white" data-id="element-3083" />
                Empezar Ahora
                <div className="absolute inset-0 rounded-xl overflow-hidden pointer-events-none" data-id="element-3084">
                  <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-[-25deg] group-hover:animate-shine" data-id="element-3085" />
                </div>
              </button>
            </a>
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <Footer data-id="element-3086" />
    </div>;
}